import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-comment-form',
  templateUrl: './comment-form.component.html',
  styleUrl: './comment-form.component.scss'
})
export class CommentFormComponent implements OnInit {

  @Input() submitLabel!: string;
  @Input() hasCancelButton: boolean = false;
  @Input() initialText: string = '';
  @Input() initialEmail: string = '';
  @Input() initialUsername: string = '';
  @Input() initialLastname: string = '';
  @Input() initialSurname: string = '';
  @Input() initialParentId: string = '';
  @Output() handleSubmit = new EventEmitter<string>();
  @Output() handleCancel = new EventEmitter<void>();

  form!: FormGroup;

  constructor(
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      body: [this.initialText, [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d10-9.,:;?!¿¡()/-\s]+$/), Validators.minLength(5), Validators.maxLength(2024)]],
      email: [this.initialEmail, [Validators.required, Validators.email]],
      username: [this.initialUsername, [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]],
      lastname: [this.initialLastname, [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]],
      surname: [this.initialSurname, [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]],
      createdAt: [null],
      parenId: [null],
    });
  }

  onSubmit(): void {
    this.handleSubmit.emit(this.form.value);
    this.form.reset();
  }

  campoNoValido(campo: string) {
    return this.form.get(campo).invalid && this.form.get(campo).touched;
  }


  get username() {
    return this.form.get('username');
  }
  get lastname() {
    return this.form.get('lastname');
  }
  get surname() {
    return this.form.get('surname');
  }
  get email() {
    return this.form.get('email');
  }
  get body() {
    return this.form.get('body');
  }

}
